<template>
    <div :class="{
			'py-4': (isBackgroundColorEnabled || sectionImage) && !isLoading,
			'px-4': isBackgroundColorEnabled && !isLoading,
			'mt-4': sectionImage && !isLoading
		}"
		class="rounded-section p-0"
		:style="{ 'background-color': backgroundColor }"
	>
        <div class="featured-title">
			<div v-if="sectionImage && !isLoading">
				<div class="row">
					<div class="col col-md-auto text-center">
						<img class="section-image ml-2 mr-4" :src="sectionImage" />
					</div>
					<div class="col">
						<span class="label-text" :style="{ 'color': sectionTitleColor }">{{ meta.title }}</span>
					</div>
					<div class="col-md-auto col-xs-12" v-if="user && isHaveOrder && slug === 'top-product'">
						<div class="d-flex align-items-center justify-content-end" @click="fullCatalog" :style="{ 'color': sectionTitleColor }">
							<span class="label-more">Lihat Semua</span>
							<i class="bi bi-chevron-right"></i>
						</div>
					</div>
				</div>
			</div>
			<div v-else>
				<i class="label-icon" :class="meta.icon"></i>
				<span class="label-text" :style="{ 'color': sectionTitleColor }">{{ meta.title }}</span>
			</div>
        </div>
		<div class="slider" v-if="slug === 'recomended-product'">
			<template>
				<slider-product :products="products"/>
			</template>
		</div>
        <div class="row product-items" v-else>
			<template v-if="!isLoading">
				<template v-if="(!isHaveOrder || !user) && slug === 'top-product'">
					<div v-for="(product, index) in dummyProducts" :key="index" class="col-xl-2 col-lg-3 col-md-4 col-6 d-flex justify-content-center product-item">
						<product-dummy :product="product" :isHaveOrder="isHaveOrder" :isUser="user" />
					</div>
				</template>
				<template v-else>
					<div v-for="(product, index) in products" :key="index" class="col-xl-2 col-lg-3 col-md-4 col-6 d-flex justify-content-center product-item">
						<product-item :product="product" @showDetail="showDetail(product)" />
					</div>
				</template>
			</template>
			<template v-else>
				<div v-for="(product, index) in dummyProducts" :key="index" class="col-xl-2 col-lg-3 col-md-4 col-6 d-flex justify-content-center product-item">
					<product-item :is-loading="isLoading" />
				</div>
			</template>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import ProductItem from '@/components/homepages/sections/partials/ProductItem.vue';
import ProductDummy from '@/components/homepages/sections/partials/ProductDummy.vue';
import SliderProduct from '@/components/homepages/SliderProduct.vue';
import homepageApi from '@/api/homepage';
import { getDateRange, duplicateVar } from '@/lib/helper';

export default {
	name: 'Featured',
	components: {
		ProductItem,
		ProductDummy,
		SliderProduct,
	},
	props: {
		meta: {
			type: Object,
			default: () => ({
				title: 'Featured',
				icon: 'bi-tags',
			}),
		},
		slug: {
			type: String,
			default: '',
		},
		config: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			dummyProducts: new Array(6),
			sort_by: 'created_at',
			sort: 'desc',
			page: 1,
			isLoading: true,
			products: [],
			defaultTextColor: '#4D4D4D',
		};
	},
	methods: {
		fetchProductRecomendation() {
			this.isLoading = true;

			let productIds = '62258ac4c225772c5672afd2,62b7d175e919654e33249882,62bc0bdce2108832322888e2,624cfddab5555d6648741d32';

			if (this.config !== null && this.config.length > 0) {
				const products = this.config.filter(conf => conf.product); // filter products only, exclude widget config
				const arrProductIds = products.map(item => item.product._id);
				productIds = arrProductIds.filter(a => a).join();
			}

			const params = {
				limit: 12,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				product_ids: productIds,
				use_cache_header: true,
				// status: this.status,
			};

			const callback = (response) => {
				const products = response.data.products;
				this.products = products;
				this.isLoading = false;
			};

			const errorCallback = () => {
				this.isLoading = false;
			};

			homepageApi.getPublicProducts(params, callback, errorCallback);
		},
		fetchProductFeaturedRecently() {
			if (!this.user) {
				this.isLoading = false;
				return;
			}
			this.isLoading = true;

			const defaultFilterDate = getDateRange(-7, -1); // 7 days back from today, exclude today
			const filterDate = duplicateVar(defaultFilterDate);

			const filterDateFormat = 'YYYY-MM-DD';
			const since = dayjs(filterDate.start).format(filterDateFormat);
			const until = dayjs(filterDate.end).format(filterDateFormat);

			const params = {
				limit: 6,
				sort_by: 'submission_count',
				sort: 'desc',
				page: this.page,
				use_cache_header: true,
				since,
				until,
			};

			const callback = (response) => {
				const products = response.data.products;
				this.products = products;
				this.isLoading = false;
				if (this.products.length <= 0) {
					this.fetchProductFeatured();
				}
			};

			const errorCallback = () => {
				this.isLoading = false;
				if (this.products.length <= 0) {
					this.fetchProductFeatured();
				}
			};

			homepageApi.getPublicTopProducts(params, callback, errorCallback);
		},
		fetchProductFeatured() {
			this.isLoading = true;

			const params = {
				limit: 6,
				sort_by: 'submission_count',
				sort: 'desc',
				page: this.page,
				use_cache_header: true,
				// status: this.status,
			};

			const callback = (response) => {
				const products = response.data.products;
				this.products = products;
				this.isLoading = false;
			};

			const errorCallback = () => {
				this.isLoading = false;
			};

			homepageApi.getPublicTopProducts(params, callback, errorCallback);
		},
		fetchBestMarginProduct() {
			this.isLoading = true;

			const params = {
				limit: 6,
				sort_by: 'dropship.margin',
				sort: this.sort,
				page: this.page,
				use_cache_header: true,
				// status: this.status,
			};

			const callback = (response) => {
				const products = response.data.products;
				this.products = products;
				this.isLoading = false;
			};

			const errorCallback = () => {
				this.isLoading = false;
			};

			homepageApi.getPublicProducts(params, callback, errorCallback);
		},
		fetchNewProduct() {
			this.isLoading = true;

			const params = {
				limit: 6,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				use_cache_header: true,
				// status: this.status,
			};

			const callback = (response) => {
				const products = response.data.products;
				this.products = products;
				this.isLoading = false;
			};

			const errorCallback = () => {
				this.isLoading = false;
			};

			homepageApi.getPublicProducts(params, callback, errorCallback);
		},
		fetchOtherProduct() {
			this.isLoading = true;

			let productId = '';
			let productCategorySlug = '';
			if (this.config !== null && this.config.length > 0) {
				const product = this.config[0];
				productCategorySlug = product.category.category_slug;
				productId = product._id.$oid;
			}

			const params = {
				limit: 6,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				product_id: productId,
				category_slug: productCategorySlug,
			};

			const callback = (response) => {
				const products = response.data.products;
				this.products = products;
				this.isLoading = false;
			};

			const errorCallback = () => {
				this.isLoading = false;
			};

			homepageApi.getOtherProducts(params, callback, errorCallback);
		},
		showDetail(product) {
			const encodedUserId = btoa(product.user._id.$oid);
			this.$router.push({ name: 'product-detail', params: { slug: `${product.slug}-${encodedUserId}` } });
		},
		fullCatalog() {
			this.$router.push({ name: 'search', query: { sort_by: this.slug } });
		},
		fetchFeaturedBySlug() {
			if (this.slug === 'recomended-product') {
				this.fetchProductRecomendation();
			} else if (this.slug === 'top-product') {
				this.fetchProductFeaturedRecently();
			} else if (this.slug === 'best-margin') {
				this.fetchBestMarginProduct();
			} else if (this.slug === 'new-product') {
				this.fetchNewProduct();
			} else if (this.slug === 'other-products') {
				this.fetchOtherProduct();
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		isRecommendedProduct() {
			return this.slug === 'recomended-product';
		},
		sectionImage() {
			if (this.isRecommendedProduct) {
				return this.config[12]?.section_image_url;
			}
			return this.config[0]?.section_image_url;
		},
		isBackgroundColorEnabled() {
			if (this.isRecommendedProduct) {
				return this.config[12]?.background_color?.enabled;
			}
			return this.config[0]?.background_color?.enabled;
		},
		isTextColorEnabled() {
			if (this.isRecommendedProduct) {
				return this.config[12]?.text_color?.enabled;
			}
			return this.config[0]?.text_color?.enabled;
		},
		backgroundColor() {
			const defaultBgColor = 'none';

			if (this.isLoading) {
				return defaultBgColor;
			}

			if (this.isBackgroundColorEnabled) {
				if (this.isRecommendedProduct) {
					return this.config[12]?.background_color?.color;
				}
				return this.config[0]?.background_color?.color;
			}
			return defaultBgColor;
		},
		textColor() {
			if (this.isTextColorEnabled) {
				if (this.isRecommendedProduct) {
					return this.config[12]?.text_color?.color;
				}
				return this.config[0]?.text_color?.color;
			}
			return this.defaultTextColor;
		},
		dynamicTextColor() {
			if (this.backgroundColor === 'none') {
				return this.textColor;
			}
			// get color contrast with yiq formula
			const r = parseInt(this.backgroundColor.substring(1, 3), 16);
			const g = parseInt(this.backgroundColor.substring(3, 5), 16);
			const b = parseInt(this.backgroundColor.substring(5, 7), 16);
			const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
			return (yiq >= 128) ? 'black' : 'white';
		},
		sectionTitleColor() {
			if (this.isBackgroundColorEnabled && !this.isTextColorEnabled) {
				return this.dynamicTextColor;
			}

			return this.textColor;
		},
		isHaveOrder() {
			return this.user?.submission_count >= 1;
		},
	},
	watch: {
		config() {
			this.fetchFeaturedBySlug();
		},
	},
	created() {
		this.fetchFeaturedBySlug();
	},
};
</script>
<style lang="scss" scoped>

    .featured-title {
		// margin-left: 40px;
		margin-bottom: 25px;
		.label-icon {
			font-size: 32px;
			color: #D66956;
			margin-right: 20px;
		}
		.label-text {
			font-style: normal;
			font-weight: 600;
			font-size: 28px;
			color: #4D4D4D;
		}

		.label-more {
			font-size: 18px;
			font-weight: 600;
			cursor: pointer;
		}
	}

	.product-item {
		padding-left: 8px;
		padding-right: 8px;
	}
	.row.product-items {
		margin-left: -8px;
		margin-right: -8px;
	}

	.section-image {
		max-width: 300px;
		max-height: 150px;
		margin-top: -50px;
	}

	.rounded-section {
		border-radius: 5px;
	}

	.bi::before {
		font-weight: 900 !important;
		font-size: 16px !important;
	}
</style>
